export const ADD_ONBAORDING_DATA_REQUEST = 'ADD_ONBOARDING_DATA_REQUEST';
export const ADD_ONBAORDING_DATA_SUCCESS = 'ADD_ONBAORDING_DATA_SUCCESS';
export const ADD_ONBAORDING_DATA_FAILURE = 'ADD_ONBAORDING_DATA_FAILURE';
